import React from 'react';
import ReactDOM from 'react-dom/client';
import { SuiClientProvider, WalletProvider } from '@mysten/dapp-kit';
import { getFullnodeUrl } from '@mysten/sui/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import '@mysten/dapp-kit/dist/index.css';
import './index.css';

// ═══════════════════════════════════════════════════════════════════════════
// DISTIL PROTOCOL - MAIN ENTRY POINT
// RPC calls route through /api/rpc (Vercel serverless proxy → Shinami)
// API key stays server-side, CORS handled automatically by Vercel
// ═══════════════════════════════════════════════════════════════════════════

const networks = {
  mainnet: { url: '/api/rpc' },
  testnet: { url: getFullnodeUrl('testnet') },
  devnet: { url: getFullnodeUrl('devnet') },
};

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <SuiClientProvider networks={networks} defaultNetwork="mainnet">
        <WalletProvider autoConnect>
          <App />
        </WalletProvider>
      </SuiClientProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
